import React, { useCallback, useEffect, useRef, useState } from "react";
import cookieLogo from "../../interviewAI/assets/newlogo/VIRIQO_HIRES_Logo.png";
import { saveCookieConsent } from "../services/webTracking";

const COOKIE_BANNER_STYLES = `\n
:root {
  --purple:#790FA8;
  --violet:#A66FFF;
  --blue:#3E9BEF;
  --ink:#0B1B45;
  --ink-2:#475467;
  --ink-3:#667085;
  --lilac:#F1ECFF;
  --ease:cubic-bezier(.22,1,.36,1);
}

.ttc{position:fixed;left:0;right:0;bottom:clamp(12px,2.5vw,32px);z-index:90;padding:0 clamp(12px,2.5vw,40px);pointer-events:none}
.ttc-card{pointer-events:auto;width:100%;max-width:1360px;margin:0 auto;display:grid;grid-template-columns:142px minmax(420px,1fr) auto;align-items:center;gap:clamp(22px,2.25vw,32px);
  padding:clamp(18px,1.7vw,22px) clamp(22px,2vw,30px);background:#F4F6FF;border:1px solid #DDE2F0;border-radius:14px;
  box-shadow:0 10px 28px -20px rgba(11,27,69,.35);
  transform:translateY(calc(100% + 60px));opacity:0;transition:transform .8s var(--ease),opacity .6s}
.ttc.show .ttc-card{transform:none;opacity:1}
.ttc.leave .ttc-card{transform:translateY(calc(100% + 60px));opacity:0;transition-duration:.55s}
.ttc-brand{position:relative;padding-right:28px;align-self:stretch;display:flex;align-items:center;justify-content:flex-start}
.ttc-brand::after{content:"";position:absolute;right:0;top:0;bottom:0;width:1px;background:#D3D8E5;transform:scaleY(0);transform-origin:top;transition:transform .7s var(--ease) .45s}
.ttc.show .ttc-brand::after{transform:scaleY(1)}
.ttc-brand img{display:block;width:110px;max-width:100%;height:auto;opacity:0;transform:translateX(-12px);transition:all .7s var(--ease) .3s}
.ttc.show .ttc-brand img{opacity:1;transform:none}
.ttc-text{font-size:15px;line-height:1.5;color:#667085;max-width:620px;margin:0;opacity:0;transform:translateY(8px);transition:all .7s var(--ease) .4s}
.ttc.show .ttc-text{opacity:1;transform:none}
.ttc-text a{color:var(--purple);text-decoration:underline;text-underline-offset:3px;font-weight:500}
.ttc-actions{display:flex;align-items:center;gap:clamp(12px,1.6vw,24px);opacity:0;transform:translateY(8px);transition:all .7s var(--ease) .5s}
.ttc.show .ttc-actions{opacity:1;transform:none}
.ttc-link{font-size:15px;font-weight:600;color:var(--purple);text-decoration:underline;text-underline-offset:4px;white-space:nowrap;padding:8px 2px;transition:color .25s}
.ttc-link:hover{color:var(--violet)}
.ttc-btn{height:44px;padding:0 26px;border-radius:8px;font-size:15px;font-weight:600;white-space:nowrap;display:inline-flex;align-items:center;justify-content:center;transition:background .3s,color .3s,transform .3s var(--ease),box-shadow .3s;position:relative;overflow:hidden}
.ttc-btn:hover{transform:translateY(-2px)}
.ttc-btn:focus-visible,.ttc-link:focus-visible,.ttc-x:focus-visible,.ttc-sw input:focus-visible+span{outline:3px solid rgba(166,111,255,.55);outline-offset:2px}
.ttc-out{background:#fff;border:1.5px solid var(--purple);color:var(--purple);min-width:118px}
.ttc-out:hover{background:var(--lilac)}
.ttc-solid{background:linear-gradient(105deg,var(--blue) 0%,#397EDB 36%,var(--purple) 100%);color:#fff;border:0;box-shadow:0 12px 24px -12px rgba(75,20,152,.75)}
.ttc-solid::after{content:"";position:absolute;inset:0;background:linear-gradient(110deg,transparent 30%,rgba(255,255,255,.35) 50%,transparent 70%);transform:translateX(-120%);animation:ttcSheen 3.8s var(--ease) 1.6s infinite}
@keyframes ttcSheen{45%,100%{transform:translateX(120%)}}
.ttc-solid:hover{background:linear-gradient(105deg,#2D8FE7 0%,#346FC9 36%,#670C92 100%);box-shadow:0 14px 26px -12px rgba(75,20,152,.85)}

@media(max-width:1180px){
  .ttc-card{grid-template-columns:142px minmax(0,1fr)}
  .ttc-actions{grid-column:1/-1;justify-content:flex-end;padding-top:18px;border-top:1px solid #E6E0F5}
}
@media(max-width:720px){
  .ttc{bottom:8px;padding:0 8px}
  .ttc-card{grid-template-columns:1fr;gap:16px;padding:20px}
  .ttc-brand{padding:0 0 14px;align-self:auto}
  .ttc-brand::after{left:0;right:auto;top:auto;bottom:0;width:48px;height:2px;transform:scaleX(0);transform-origin:left;background:linear-gradient(90deg,var(--purple),var(--violet))}
  .ttc.show .ttc-brand::after{transform:scaleX(1)}
  .ttc-brand img{width:112px}
  .ttc-text{font-size:14px}
  .ttc-actions{display:grid;grid-template-columns:1fr 1fr;gap:10px;border-top:0;padding-top:4px}
  .ttc-actions .ttc-link{grid-column:1/-1;order:3;justify-self:center}
  .ttc-btn{width:100%;padding:0 12px}
}
@media(max-width:430px){.ttc-actions{grid-template-columns:1fr}.ttc-actions .ttc-solid{order:-1}}

/* ---------- settings dialog ---------- */
.ttc-modal{position:fixed;inset:0;z-index:100;display:grid;place-items:center;padding:16px;background:rgba(25,31,45,.55);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);opacity:0;visibility:hidden;transition:opacity .4s,visibility .4s}
.ttc-modal.open{opacity:1;visibility:visible}
.ttc-dlg{width:100%;max-width:660px;max-height:calc(100vh - 32px);overflow:auto;background:#fff;border-radius:22px;box-shadow:0 40px 90px -30px rgba(25,31,45,.6);transform:translateY(24px) scale(.97);transition:transform .55s var(--ease)}
.ttc-modal.open .ttc-dlg{transform:none}
.ttc-head{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:26px 30px 22px;border-bottom:1px solid #EEEAF7}
.ttc-head img{display:block;width:132px;height:auto}
.ttc-x{width:40px;height:40px;border-radius:10px;display:grid;place-items:center;color:var(--ink-3);transition:background .25s,color .25s,transform .4s var(--ease)}
.ttc-x:hover{background:var(--lilac);color:var(--purple);transform:rotate(90deg)}
.ttc-x svg{width:20px;height:20px}
.ttc-body{padding:26px 30px 8px}
.ttc-body h2{font-size:24px;margin:0;letter-spacing:-.02em}
.ttc-body>p{font-size:15px;color:var(--ink-2);margin-top:8px}
.ttc-cat{display:flex;gap:18px;align-items:flex-start;justify-content:space-between;padding:20px;border:1px solid #EEEAF7;border-radius:16px;margin-top:14px;opacity:0;transform:translateY(12px);transition:opacity .5s,transform .6s var(--ease),border-color .3s,background .3s}
.ttc-modal.open .ttc-cat{opacity:1;transform:none}
.ttc-modal.open .ttc-cat:nth-of-type(1){transition-delay:.12s}.ttc-modal.open .ttc-cat:nth-of-type(2){transition-delay:.2s}.ttc-modal.open .ttc-cat:nth-of-type(3){transition-delay:.28s}
.ttc-cat:first-of-type{margin-top:22px}
.ttc-cat.on{border-color:rgba(166,111,255,.5);background:#FCFAFF}
.ttc-cat b{display:block;font-size:16px;color:var(--ink)}
.ttc-cat span.d{display:block;font-size:14px;color:var(--ink-3);margin-top:4px}
.ttc-tag{font-size:12px;font-weight:700;color:#12805C;background:#E5F7EF;border-radius:999px;padding:5px 10px;white-space:nowrap}
.ttc-sw{position:relative;flex:none;width:48px;height:28px;cursor:pointer}
.ttc-sw input{position:absolute;opacity:0;width:100%;height:100%;margin:0;cursor:pointer}
.ttc-sw span{position:absolute;inset:0;border-radius:999px;background:#D9D5E4;transition:background .35s}
.ttc-sw span::after{content:"";position:absolute;left:3px;top:3px;width:22px;height:22px;border-radius:50%;background:#fff;box-shadow:0 2px 6px rgba(25,31,45,.25);transition:transform .45s var(--ease)}
.ttc-sw input:checked+span{background:var(--purple)}
.ttc-sw input:checked+span::after{transform:translateX(20px)}
.ttc-foot{display:flex;justify-content:flex-end;flex-wrap:wrap;gap:12px;padding:22px 30px 28px}
@media(max-width:560px){.ttc-head,.ttc-body,.ttc-foot{padding-left:20px;padding-right:20px}.ttc-foot .ttc-btn{flex:1 1 100%}}

/* ---------- toast ---------- */
.ttc-toast{position:fixed;left:50%;bottom:28px;z-index:95;transform:translate(-50%,20px);opacity:0;visibility:hidden;display:flex;align-items:center;gap:10px;padding:12px 18px;border-radius:999px;background:var(--ink);color:#fff;font-size:14px;font-weight:500;box-shadow:0 20px 40px -18px rgba(25,31,45,.6);transition:all .5s var(--ease)}
.ttc-toast.show{opacity:1;visibility:visible;transform:translate(-50%,0)}
.ttc-toast i{width:20px;height:20px;border-radius:50%;background:var(--violet);display:grid;place-items:center}
.ttc-toast i svg{width:12px;height:12px}\n`;

const KEY = "tt_consent";
const VERSION = 1;

const readConsent = () => {
  try {
    const value = JSON.parse(localStorage.getItem(KEY));
    return value && value.v === VERSION ? value : null;
  } catch {
    return null;
  }
};

const publishConsent = (consent) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "tt_consent_update",
    analytics: consent.analytics,
    marketing: consent.marketing,
  });

  window.dispatchEvent(
    new CustomEvent("tt:consent", {
      detail: consent,
    })
  );
};

const CookieBanner = () => {
  const [bannerVisible, setBannerVisible] = useState(false);
  const [bannerShown, setBannerShown] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [toast, setToast] = useState("");

  const closeButtonRef = useRef(null);
  const lastFocusRef = useRef(null);
  const toastTimerRef = useRef(null);

  const prefersReducedMotion = useCallback(
    () => window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    []
  );

  const showBanner = useCallback(() => {
    setBannerVisible(true);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setBannerShown(true));
    });
  }, []);

  const hideBanner = useCallback(() => {
    setBannerShown(false);

    const delay = prefersReducedMotion() ? 0 : 600;
    window.setTimeout(() => setBannerVisible(false), delay);
  }, [prefersReducedMotion]);

  const showToast = useCallback((message) => {
    setToast(message);
    window.clearTimeout(toastTimerRef.current);
    toastTimerRef.current = window.setTimeout(() => setToast(""), 2600);
  }, []);

  const saveConsent = useCallback(
    (analyticsValue, marketingValue, message, action) => {
      const nextConsent = {
        v: VERSION,
        necessary: true,
        analytics: Boolean(analyticsValue),
        marketing: Boolean(marketingValue),
        ts: new Date().toISOString(),
      };

      try {
        localStorage.setItem(KEY, JSON.stringify(nextConsent));
      } catch {
        // Continue even when storage is unavailable.
      }

      publishConsent(nextConsent);
      // Do not make the consent UI depend on telemetry availability. The API
      // persists the required consent record and its dashboard tracking row.
      saveCookieConsent({
        analytics: nextConsent.analytics,
        marketing: nextConsent.marketing,
        action,
      }).catch((error) => console.warn("Cookie consent tracking failed:", error));

      if (settingsOpen) {
        setSettingsOpen(false);
      }

      hideBanner();
      showToast(message);
    },
    [hideBanner, settingsOpen, showToast]
  );

  const openSettings = useCallback(() => {
    const current = readConsent();
    setAnalytics(current ? Boolean(current.analytics) : false);
    setMarketing(current ? Boolean(current.marketing) : false);
    lastFocusRef.current = document.activeElement;
    setSettingsOpen(true);
  }, []);

  const closeSettings = useCallback(() => {
    setSettingsOpen(false);
    document.body.style.overflow = "";

    if (lastFocusRef.current && typeof lastFocusRef.current.focus === "function") {
      lastFocusRef.current.focus();
    }
  }, []);

  const resetConsent = useCallback(() => {
    try {
      localStorage.removeItem(KEY);
    } catch {
      // Ignore storage errors.
    }

    setAnalytics(false);
    setMarketing(false);
    setSettingsOpen(false);
    setToast("");
    saveCookieConsent({ analytics: false, marketing: false, action: "reset" }).catch(
      (error) => console.warn("Cookie consent reset tracking failed:", error)
    );
    showBanner();
  }, [showBanner]);

  useEffect(() => {
    const saved = readConsent();

    if (saved) {
      publishConsent(saved);
      return undefined;
    }

    const timer = window.setTimeout(showBanner, 900);
    return () => window.clearTimeout(timer);
  }, [showBanner]);

  useEffect(() => {
    window.TTConsent = {
      open: openSettings,
      get: readConsent,
      reset: resetConsent,
    };
    window.openCookieSettings = openSettings;

    return () => {
      if (window.TTConsent) {
        delete window.TTConsent;
      }
      if (window.openCookieSettings === openSettings) {
        delete window.openCookieSettings;
      }
    };
  }, [openSettings, resetConsent]);

  useEffect(() => {
    if (!settingsOpen) return undefined;

    document.body.style.overflow = "hidden";
    const focusTimer = window.setTimeout(() => closeButtonRef.current?.focus(), 50);

    return () => {
      window.clearTimeout(focusTimer);
      document.body.style.overflow = "";
    };
  }, [settingsOpen]);

  useEffect(() => {
    if (!settingsOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closeSettings();
        return;
      }

      if (event.key !== "Tab") return;

      const modal = document.getElementById("ttcModal");
      if (!modal) return;

      const focusable = [...modal.querySelectorAll("button, input")];
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [closeSettings, settingsOpen]);

  useEffect(
    () => () => window.clearTimeout(toastTimerRef.current),
    []
  );

  return (
    <>
      <style>{COOKIE_BANNER_STYLES}</style>
      {bannerVisible && (
        <div
          className={`ttc ${bannerShown ? "show" : ""}`}
          id="ttc"
          role="region"
          aria-label="Cookie consent"
        >
          <div className="ttc-card">
            <div className="ttc-brand">
              <img src={cookieLogo} alt="Viriqo Hires" />
            </div>

            <p className="ttc-text" id="ttcText">
              We use cookies to enhance your experience on the Viriqo Hires website,
              understand visitor behavior, and show relevant content. Some cookies are
              required for core site functions, while others support analytics and
              marketing. Select “Accept All” to continue, or click “Cookie Settings”
              to control your choices anytime. <a href="/cookie-policy">Learn more</a> in
              our Cookie Policy.
            </p>

            <div className="ttc-actions">
              <button type="button" className="ttc-link" onClick={openSettings}>
                Cookie Setting
              </button>
              <button
                type="button"
                className="ttc-btn ttc-out"
                onClick={() => saveConsent(false, false, "Optional cookies rejected", "reject_all")}
              >
                Reject All
              </button>
              <button
                type="button"
                className="ttc-btn ttc-solid"
                onClick={() => saveConsent(true, true, "All cookies accepted", "accept_all")}
              >
                Accept All Cookies
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        className={`ttc-modal ${settingsOpen ? "open" : ""}`}
        id="ttcModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ttcTitle"
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) closeSettings();
        }}
      >
        <div className="ttc-dlg">
          <div className="ttc-head">
            <img src={cookieLogo} alt="Viriqo Hires" />
            <button
              ref={closeButtonRef}
              type="button"
              className="ttc-x"
              onClick={closeSettings}
              aria-label="Close cookie settings"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          </div>

          <div className="ttc-body">
            <h2 id="ttcTitle">Cookie Settings</h2>
            <p>Choose which cookies you allow. You can change these choices anytime.</p>

            <div className="ttc-cat on">
              <div>
                <b>Strictly necessary</b>
                <span className="d">Required for core site functions. These are always on.</span>
              </div>
              <span className="ttc-tag">Always active</span>
            </div>

            <div className={`ttc-cat ${analytics ? "on" : ""}`} data-cat="analytics">
              <div>
                <b>Analytics</b>
                <span className="d">Help us understand visitor behavior and improve the website.</span>
              </div>
              <label className="ttc-sw">
                <input
                  type="checkbox"
                  checked={analytics}
                  onChange={(event) => setAnalytics(event.target.checked)}
                  aria-label="Allow analytics cookies"
                />
                <span />
              </label>
            </div>

            <div className={`ttc-cat ${marketing ? "on" : ""}`} data-cat="marketing">
              <div>
                <b>Marketing</b>
                <span className="d">Used to show you relevant content.</span>
              </div>
              <label className="ttc-sw">
                <input
                  type="checkbox"
                  checked={marketing}
                  onChange={(event) => setMarketing(event.target.checked)}
                  aria-label="Allow marketing cookies"
                />
                <span />
              </label>
            </div>
          </div>

          <div className="ttc-foot">
            <button
              type="button"
              className="ttc-btn ttc-out"
              onClick={() => saveConsent(false, false, "Optional cookies rejected", "reject_all")}
            >
              Reject All
            </button>
            <button
              type="button"
              className="ttc-btn ttc-out"
              onClick={() => saveConsent(analytics, marketing, "Cookie preferences saved", "save_preferences")}
            >
              Save Preferences
            </button>
            <button
              type="button"
              className="ttc-btn ttc-solid"
              onClick={() => saveConsent(true, true, "All cookies accepted", "accept_all")}
            >
              Accept All Cookies
            </button>
          </div>
        </div>
      </div>

      <div className={`ttc-toast ${toast ? "show" : ""}`} id="ttcToast" role="status" aria-live="polite">
        <i>
          <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </i>
        <span>{toast}</span>
      </div>
    </>
  );
};

export default CookieBanner;
